function updateForms()
{
    $('.form-group:not(.form-group--editable)').each(function () {
        if ($('input',this).val() == '') {
            $(this).removeClass('is-active');
        } else {
            $(this).addClass('is-active');
        }
    });
}

(function ($) {
    $(function () {

        // CUSTOM NUMBER INPUT CHANGES
        $('.form-group').click(function () {
            updateForms();
            $(this).addClass('is-active');
        });

        // CUSTOM NUMBER INPUT CHANGES
        $('.form-group input').on('focus',function () {
            updateForms();
            $(this).parents('.form-group').addClass('is-active');
        });

        // CLICK SOMEWHERE ELSE
        $(document).mouseup(function (e) {
            var container = $('.form-group');
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                updateForms();
            }
        });

        // REMOVING HAS-ERROR CLASS
        $(document).on('focusin', '.form-group.has-error input', function () {
            $(this).parent().removeClass('has-error');
        });

        // SEND JS FORM SPECIFIC ELEMENT
        $('.js-form .js-send-element').click(function () {
            var action = $(this).parents('.js-form').attr('action');
            var inputElement = $($(this).data('id'));
            var formData = $(this).parents('.js-form').serialize();
            $.ajax({
                url: action,
                method: "POST",
                dataType: 'json',
                data: formData,
                success: function (data) {
                    $(inputElement).parents('.js-form').removeClass('has-error');
                    $(inputElement).parents('.js-form').find('.edit').show();
                    $(inputElement).parents('.js-form').find('.cta').hide();
                    $(inputElement).parents('.form-group').find('.form-control').addClass('inactive');
                    $(inputElement).parents('.form-group').find('.phone-number').addClass('inactive');
                    if ($(inputElement).attr('id') === 'password_old') {
                        $('#password_old').val('');
                        $('#password').val('');
                        $('#password_confirm').val('');
                    }
                    $('.profile-success-update').addClass('d-none');
                    $(inputElement).parents('.js-form').find('.profile-success-update').removeClass('d-none');
                },
                error: function (data) {
                    $(inputElement).parents('.js-form').addClass('has-error');
                    $(inputElement).parents('.js-form').find('.error-text').remove();
                    $.each(data.responseJSON.messages, function (key, values) {
                        key = key.split('.').join('_');
                        var id = '#' + key;
                        $(id).parent('div').append('<div class="error-text p-relative bottom-0">' + values.join('<br>') + '</div>');
                    });
                    $('.profile-success-update').addClass('d-none');
                }
            });
        });

    });
})(jQuery);
